class QuickViewElement extends ModalComponent {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    GSP.pubsub.subscribe(GSP.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => {
      this.hide();
    });
  }
  get sourceSelector() {
    return "#MainProduct-quick-view__content";
  }
  onShowHandler() {
    GSP.pubsub.publish(GSP.pubsub.PUB_SUB_EVENTS.quickViewShow, {});
  }
  onShownHandler() {
    GSP.bsScript.tooltips();
    const countdown = this.querySelector(".gsp-simple-countdown");
    if (countdown) {
      GSP.processCountdown.init();
    }
  }
  onHiddenHandler() {
    super.onHiddenHandler();
    this.body.innerHTML = "";
  }
  onButtonClick(event, button) {
    const url = button.dataset.productHandle;
    this.fetchHtml(button, url);
  }
  async fetchHtml(button, url) {
    if (!url) {
      return;
    }
    if (button) {
      gspTheme.helper.enableLoadingSpiner(button);
    }
    const options = {
      url: `${window.gspSetting.base_url}products/${url}`,
      fromCache: true
    };
    await gspTheme.helper.fetchSection(this.sectionId, options).then(((response) => {
      const productElement = response.querySelector(this.sourceSelector);
      if (productElement) {
        this.setInnerHTML(this.body, productElement.content.cloneNode(true));
        if (button && button.hasAttribute("data-bs-toggle")) {
          this.hideTooltipButton(button);
        }
      }
    })).catch(((error) => {
      if (button) {
        gspTheme.helper.disableLoadingSpinner(button);
      }
    })).finally((() => {
      if (button) {
        gspTheme.helper.disableLoadingSpinner(button);
      }
      this.show();
    }));
  }
  setInnerHTML(element, innerHTML) {
    element.innerHTML = "";
    element.appendChild(innerHTML);
  }
  hideTooltipButton(button) {
    const tooltip = bootstrap.Tooltip.getInstance(button);
    if (tooltip) {
      tooltip.hide();
    }
  }
  showOnDesignMode() {
    if (this.type === "offcanvas") {
      this.instance._focustrap._isActive = true;
    }
    const url = this.dataset.productHandle;
    this.fetchHtml(false, url);
  }
}
customElements.define("quick-view", QuickViewElement);
